export default {
  apiUrl: process.env.VUE_APP_API_URL || "https://dev.api.wipon.pro",
  apiVersion: "v1",
};
